(() => {
  if (window.NFManagedVideo) {
    window.NFManagedVideo.init(document);
    return;
  }

  const SLOW_UNTIL = 2;
  const SLOW_RATE = 0.85;
  const VISIBILITY_THRESHOLD = 0.2;

  const setup = (wrap) => {
    if (!wrap || wrap.dataset.nfManagedVideoReady === 'true') return;

    const video = wrap.querySelector('video');
    const button = wrap.querySelector('[data-nf-managed-video-control]');
    const section = wrap.closest('[data-nf-managed-video-section]') || wrap;

    if (!video || !button || !section) return;

    wrap.dataset.nfManagedVideoReady = 'true';

    const syncRate = () => {
      const targetRate = video.currentTime < SLOW_UNTIL ? SLOW_RATE : 1;
      if (video.playbackRate !== targetRate) video.playbackRate = targetRate;
    };

    const syncControl = () => {
      const paused = video.paused;
      button.classList.toggle('is-paused', paused);
      button.setAttribute('aria-label', paused ? 'Lire la vidéo' : 'Mettre la vidéo en pause');
    };

    const playVideo = () => {
      const promise = video.play();
      if (promise && typeof promise.catch === 'function') promise.catch(() => {});
    };

    video.addEventListener('loadedmetadata', syncRate);
    video.addEventListener('timeupdate', syncRate);
    video.addEventListener('seeking', syncRate);
    video.addEventListener('play', syncControl);
    video.addEventListener('pause', syncControl);

    button.addEventListener('click', () => {
      if (video.paused) playVideo();
      else video.pause();
      syncControl();
    });

    video.pause();
    syncRate();
    syncControl();

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target !== section) return;
          if (entry.isIntersecting && entry.intersectionRatio >= VISIBILITY_THRESHOLD) playVideo();
          else video.pause();
          syncControl();
        });
      }, { threshold: [0, VISIBILITY_THRESHOLD] });

      observer.observe(section);
    }
  };

  const init = (root) => {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('[data-nf-managed-video-wrap]').forEach(setup);
  };

  window.NFManagedVideo = { init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
